import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { fromEvent, Subscription } from 'rxjs';
import { distinctUntilChanged, debounceTime, filter } from 'rxjs/operators';
import { inverseOfTranslation, vhToPixels } from '../../helpers/viewport.helpers';
import { IFacility } from '../../interfaces/facility';

import { ɵɵCdkVirtualScrollViewport, ɵɵCdkFixedSizeVirtualScroll, ɵɵCdkVirtualForOf } from '@angular/cdk/overlay';
import { CdkVirtualScrollViewportPatchDirective } from '../../directives/cdk-virtual-scroll-viewport-patch.directive';
import { TableChevronHeaderComponent } from '../../../../../shared/src/lib/components/table-chevron-header/table-chevron-header.component';
import { TranslateModule } from '@ngx-translate/core';
import { TableCellComponent, TableComponent, TableHeaderComponent, TableRowComponent } from 'shared';

@Component({
    selector: 'app-facility-list',
    templateUrl: './facility-list.component.html',
    styleUrls: ['./facility-list.component.scss'],
    imports: [
    ɵɵCdkVirtualScrollViewport,
    CdkVirtualScrollViewportPatchDirective,
    ɵɵCdkFixedSizeVirtualScroll,
    TableComponent,
    TableHeaderComponent,
    TableChevronHeaderComponent,
    ɵɵCdkVirtualForOf,
    TableRowComponent,
    RouterLink,
    TableCellComponent,
    TranslateModule
],
})
export class FacilityListComponent implements OnInit, OnDestroy {
  @Input()
  facilities: IFacility[];

  @ViewChild('virtualScrollport')
  public virtualScrollport?: CdkVirtualScrollViewport;
  public viewPortHeightInPx = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  public virtualScrollPortBufferHeight = vhToPixels(this.viewPortHeightInPx);
  public get inverseOfTranslation(): string {
    return inverseOfTranslation(this.virtualScrollport);
  }
  protected subscriptions = new Subscription();
  private readonly navigationEndEvents = this.router.events.pipe(
    filter((e) => e instanceof NavigationEnd && /view\/\d+;tab=facilities/.test(e.url)),
  );

  constructor(private readonly router: Router) {}

  ngOnInit(): void {
    this.subscriptions.add(this.navigationEndEvents.subscribe(() => globalThis.dispatchEvent(new Event('resize'))));

    this.subscriptions.add(
      fromEvent(globalThis, 'resize')
        .pipe(distinctUntilChanged(), debounceTime(10))
        .subscribe(() => {
          this.virtualScrollport?.checkViewportSize();
        }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
